import { ViewStateEntry, ViewStateKey } from '@mri-platform/shared/core';
import { createAction, props } from '@ngrx/store';

export const set = createAction('[ViewState] Set', props<{ entry: ViewStateEntry }>());

export const clean = createAction('[ViewState] Clean', props<ViewStateKey>());
